module.exports = "../../../../platform/assets/pageMainIcon/icon-riqi-3-blue.svg";